import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import { SinglePurchasePriceCaption } from '../../../../components/CTAs/components/SinglePurchasePriceCaption.js';
import '@grandvisionhq/common';
import { useAccessoriesEcommContext } from '../../../context/AccessoriesEcommContext.js';

const AccessoriesCTACaption = ()=>{
    const { getLabel  } = useIntl();
    const { quantity  } = useAccessoriesEcommContext();
    const { displayPrice  } = useProductData();
    var _discountedPrice;
    const unitPrice = (_discountedPrice = displayPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : displayPrice.originalPrice;
    const totalPrice = quantity * unitPrice;
    const addToCartLabel = getLabel('products.actions.addToCart');
    if (isNumber(totalPrice) && quantity > 1) {
        return /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body-head"
        }, addToCartLabel, /*#__PURE__*/ React.createElement(SinglePurchasePriceCaption, {
            isCentAmount: false,
            price: totalPrice
        }));
    }
    return /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, addToCartLabel);
};

export { AccessoriesCTACaption };
//# sourceMappingURL=AccessoriesCTACaption.js.map
